import { render, staticRenderFns } from "./placeOrder.vue?vue&type=template&id=56d071d0&scoped=true"
import script from "./placeOrder.vue?vue&type=script&lang=js"
export * from "./placeOrder.vue?vue&type=script&lang=js"
import style0 from "./placeOrder.vue?vue&type=style&index=0&id=56d071d0&lang=css"
import style1 from "./placeOrder.vue?vue&type=style&index=1&id=56d071d0&lang=scss&scoped=true"
import style2 from "./placeOrder.vue?vue&type=style&index=2&id=56d071d0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d071d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56d071d0')) {
      api.createRecord('56d071d0', component.options)
    } else {
      api.reload('56d071d0', component.options)
    }
    module.hot.accept("./placeOrder.vue?vue&type=template&id=56d071d0&scoped=true", function () {
      api.rerender('56d071d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/orderList/placeOrder.vue"
export default component.exports